export default __webpack_public_path__ + "static/media/mouth.a212af96.png";